import { FC, ReactNode } from 'react'
import { GalleryCard, GalleryCardType } from './Card'
import { GalleryItem, GalleryItemType } from './Item'

const Gallery: FC & GalleryCardType & GalleryItemType = (): ReactNode => <></>

Gallery.Card = GalleryCard
Gallery.Item = GalleryItem

export default Gallery
